<template>
    <div class="main">
        <c-panel title="LISTA DE ESPERA — CRECHE" titleIcon="fas fa-baby">
            <div style="color: #909399; font-size: 12px; margin-bottom: 15px;">
                Ordenação canônica: <strong>maior pontuação social</strong> primeiro; em caso de empate, <strong>inscrição mais antiga</strong> primeiro.
            </div>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Vaga (turma/faixa)">
                            <el-select v-model="filtro.vaga_id" filterable clearable @change="load" placeholder="Filtrar por vaga">
                                <el-option v-for="v in vagas" :key="v.id" :label="`${v.nome}${v.idade ? ' (' + v.idade + ' anos)' : ''}${v.instituicao_nome ? ' — ' + v.instituicao_nome : ''}`" :value="v.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Data de referência">
                            <el-date-picker v-model="filtro.data_referencia" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" @change="load" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" style="padding-top: 24px;">
                        <div class="u-text-right">
                            <el-button @click="imprimir" type="primary" plain>
                                <i class="el-icon-printer"></i> IMPRIMIR
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 50px;">Pos.</th>
                            <th>Nome do candidato</th>
                            <th>Responsável</th>
                            <th class="hidden-mobile">Vaga/Turma</th>
                            <th style="width: 80px;">Idade</th>
                            <th style="width: 100px;">Pontuação</th>
                            <th style="width: 130px;">Inscrição</th>
                            <th style="width: 120px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="status">
                        <tr v-for="(item, idx) in items" :key="item.pre_matricula_id">
                            <td><strong>{{ idx + 1 }}º</strong></td>
                            <td>{{ item.nome }}</td>
                            <td>{{ item.responsavel || '—' }}</td>
                            <td class="hidden-mobile">{{ item.curso_nome }}</td>
                            <td>{{ formatIdade(item.idade_meses) }}</td>
                            <td>
                                <span style="font-weight: bold; color: #409eff;">{{ item.pontuacao_social.toFixed(2) }}</span>
                            </td>
                            <td>{{ formatData(item.data_inscricao) }}</td>
                            <td class="u-text-center">
                                <el-button @click="abrirEditarPontuacao(item)" size="mini" type="primary" plain>
                                    <i class="el-icon-edit"></i> Pontuação
                                </el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td colspan="8" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum candidato em espera no filtro atual.</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!status" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
            </div>

            <el-dialog title="Atualizar pontuação social" :visible.sync="modalVisivel" width="400px">
                <el-form label-position="top">
                    <el-form-item label="Candidato">
                        <strong>{{ candidatoEdicao.nome }}</strong>
                    </el-form-item>
                    <el-form-item label="Pontuação social">
                        <el-input-number v-model="candidatoEdicao.pontuacao_social" :min="0" :max="100" :step="0.5" :precision="2" style="width: 100%;"></el-input-number>
                        <div style="color: #909399; font-size: 12px; margin-top: 4px;">
                            Use 0 a 100 para fácil leitura. Valores maiores avançam o candidato na fila.
                        </div>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalVisivel = false">Cancelar</el-button>
                    <el-button class="u-ml-10" type="primary" @click="salvarPontuacao">SALVAR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        status: false,
        items: [],
        vagas: [],
        filtro: { vaga_id: '', data_referencia: '' },
        modalVisivel: false,
        candidatoEdicao: { pre_matricula_id: null, nome: '', pontuacao_social: 0 }
    }),
    mounted () {
        this.filtro.data_referencia = new Date().toISOString().substring(0, 10)
        this.carregarVagas()
        this.load()
    },
    methods: {
        carregarVagas () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/lista-espera-creche/vagas`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.vagas = r.data || [] }).catch(() => { this.vagas = [] })
        },
        load () {
            this.status = false
            this.items = []
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/lista-espera-creche/listar`,
                { params: this.filtro, ...this.$store.getters.getHeaderAuth }
            ).then(r => {
                this.items = r.data || []
                this.status = true
            }).catch(e => { this.status = true; this.$store.commit('throwException', e) })
        },
        imprimir () {
            // Abre no modal padrão de PDF do sistema (event bus 'print').
            window.eventBus.$emit('print', {
                url: '/api/lista-espera-creche/imprimir',
                param: { vaga_id: this.filtro.vaga_id, data_referencia: this.filtro.data_referencia }
            })
        },
        abrirEditarPontuacao (item) {
            this.candidatoEdicao = {
                pre_matricula_id: item.pre_matricula_id,
                nome: item.nome,
                pontuacao_social: parseFloat(item.pontuacao_social) || 0
            }
            this.modalVisivel = true
        },
        salvarPontuacao () {
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/lista-espera-creche/atualizarPontuacao/${this.candidatoEdicao.pre_matricula_id}`,
                { pontuacao_social: this.candidatoEdicao.pontuacao_social },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Pontuação atualizada.', type: 'success' })
                this.modalVisivel = false
                this.load()
            }).catch(e => this.$store.commit('throwException', e))
        },
        formatIdade (meses) {
            if (meses === null || meses === undefined) return '—'
            if (meses < 24) return meses + ' meses'
            const anos = Math.floor(meses / 12)
            const m = meses % 12
            return anos + 'a ' + m + 'm'
        },
        formatData (data) {
            if (!data) return '—'
            return this.$moment(data).format('DD/MM/YYYY')
        }
    }
}
</script>
